module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjMxMyAxMGMuMDg2IDAgLjI0NC0uNTExLjQ3NS0xLjUzM2wuMDM0LS4xOTktMTIuNzM3LS40MjZMMTQgNi42NzV2LjEyM0MxNCAzLjA0NCAxMC44NjYgMCA3IDBTMCAzLjA0NCAwIDYuNzk4YzAgLjk5LjIxNyAxLjkyOS42MDggMi43NzYuMDQ1LjA5NyAzLjYxNi4yMzkgMTAuNzE1LjQyNmgxLjk5eiIgZmlsbD0iI0E1QjFDQiIgZmlsbC1ydWxlPSJldmVub2RkIiBmaWxsLW9wYWNpdHk9Ii41Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/night.svg
// module id = 190
// module chunks = 0